import { MAX_WIDTH } from "@/utils/constant";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Head from "next/head";

import BannerInstallPWA from "../BannerInstallPWA";
import FQAs from "./FQAs";
import Header from "./Header";
import MainFeatures from "./MainFeatures";
import Points from "./Points";
import Prices from "./Prices";
import RegistrationSteps from "./RegistrationSteps";
import SafetyFeatures from "./SafetyFeatures";

const ContentWrapper = styled(Box)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const Lp = () => {
  return (
    <>
      <Head>
        <title>ホーム - X裏垢マッチングサービス「ウラハル」</title>
        {/* <meta name="description" content="Generated by create next app" /> */}
        {/* <link rel="icon" href="/favicon.ico" /> */}
      </Head>
      <BannerInstallPWA />
      <Header />
      <Grid
        container
        spacing={2}
        style={{
          marginTop: 20,
          marginRight: "auto",
          marginLeft: "auto",
          maxWidth: MAX_WIDTH,
          width: "100%"
        }}
      >
        <ContentWrapper>
          <MainFeatures />
          <Points />
          <RegistrationSteps />
          <Prices />
          <SafetyFeatures />
          <FQAs />
        </ContentWrapper>
      </Grid>
    </>
  );
};

export default Lp;
